import React from "react";

interface FormHeaderProps {
  title: string;
  subtitle: string;
  backLabel?: string;
  onBack?: () => void;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  subtitle,
  backLabel,
  onBack,
}) => {
  return (
    <div className="mb-4 flex items-start justify-between p-2">
      <div>
        <h2 className="text-[26px] font-semibold text-[#4F4F4F]">{title}</h2>
        <p className="mt-1 text-[14px] text-[#4F4F4F]">{subtitle}</p>
      </div>
      {onBack && backLabel && (
        <button
          type="button"
          onClick={onBack}
          className="font-medium text-[#1D58E2] hover:text-[#0f3cb6] transition-colors"
        >
          {backLabel}
        </button>
      )}
    </div>
  );
};
